import { Component, inject } from '@angular/core';
import {
  VehicleCategoryCreateDto,
  VehicleCategoryDto,
  VehicleCategoryExcelDownloadDto,
  VehicleCategoryService,
  VehicleCategoryUpdateDto,
} from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { VEHICLECATEGORY_CONFIG, VEHICLECATEGORY_FIELDS } from './vehicle-category.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-vehicle-category',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VehicleCategoryService, ConfirmationService],
  templateUrl: './vehicle-category.html',
  styleUrl: './vehicle-category.scss',
})
export class VehicleCategory extends BaseCrudComponent<
  VehicleCategoryDto,
  VehicleCategoryCreateDto,
  VehicleCategoryUpdateDto,
  VehicleCategoryExcelDownloadDto
> {
  service = inject(VehicleCategoryService);
  config = VEHICLECATEGORY_CONFIG;
  fields = VEHICLECATEGORY_FIELDS;

  protected prepareUpdateDto(data: any, selected: VehicleCategoryDto): VehicleCategoryUpdateDto {
    return {
      name: data.name,
      code: data.code,
      semiTrailersQuantity: data.semiTrailersQuantity,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VehicleCategory';
  }
}
